import { Link } from 'react-router-dom';
import { useLanguage } from '../helpers/language-context';

const Footer = () => {
  const { translations } = useLanguage();
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-xl font-bold text-gray-800">
              <img src="/assets/images/logo/kssb.png" alt="Semesta Logo" className="h-7 w-auto" />
              <div className="flex flex-col justify-center text-[11px] md:text-[13px] font-cambria font-bold tracking-widest leading-none text-[#28357B]">
                <span className="mb-[3px]">KUMPULAN</span>
                <span>SEMESTA</span>
              </div>
            </Link>
            <div className="text-gray-600 text-xs leading-relaxed mt-4 max-w-[70%]">
              {translations.footer?.tagline ?? "Building tomorrow's infrastructure through innovation and excellence."}
            </div>
            {/* Social Media Icons */}
            <div className="flex gap-4 mt-6">
              {/* Facebook */}
              <a href="https://www.facebook.com/KumpulanSemestaSdnBhd" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#28357B] transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                </svg>
              </a>
              {/* Instagram */}
              <a href="https://www.instagram.com/kumpulansemesta" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#28357B] transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.468.99c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                </svg>
              </a>
              {/* TikTok */}
              <a href="https://www.tiktok.com/@kumpulansemestasdnbhd" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#28357B] transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                </svg>
              </a>
              {/* LinkedIn */}
              <a href="https://www.linkedin.com/company/kumpulan-semesta-sdn-bhd/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#28357B] transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" />
                </svg>
              </a>
              {/* X */}
              <a href="https://x.com/kumpulansemesta" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#28357B] transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z" />
                </svg>
              </a>
              {/* YouTube */}
              <a href="https://www.youtube.com/@KumpulanSemestaSdnBhd" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#28357B] transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>

          {/* Services Section */}
          <div>
            <h3 className="text-gray-400 uppercase text-xs font-semibold tracking-wider mb-4">
              {translations.footer?.services ?? 'Services'}
            </h3>
            <ul className="text-xs space-y-3">
              <li>
                <span className="text-gray-700">{translations.services?.mineralMining ?? 'Mineral Mining'}</span>
              </li>
              <li>
                <span className="text-gray-700">{translations.services?.roadDevelopment ?? 'Road Development'}</span>
              </li>
              <li>
                <span className="text-gray-700">{translations.services?.quarryOperations ?? 'Quarry Operations'}</span>
              </li>
              <li>
                <span className="text-gray-700">{translations.footer?.civilEngineering ?? 'Civil Engineering'}</span>
              </li>
            </ul>
          </div>

          {/* Company Section */}
          <div>
            <h3 className="text-gray-400 uppercase text-xs font-semibold tracking-wider mb-4">
              {translations.footer?.company ?? 'Company'}
            </h3>
            <ul className="text-xs space-y-3">
              <li>
                <Link to="/about/who-we-are" className="text-gray-700 hover:text-blue-900 transition-colors">
                  {translations.footer?.aboutUs ?? 'About Us'}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-700 hover:text-blue-900 transition-colors">
                  {translations.footer?.services ?? 'Services'}
                </Link>
              </li>
              <li>
                <Link to="/career" className="text-gray-700 hover:text-blue-900 transition-colors">
                  {translations.footer?.careers ?? 'Careers'}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-700 hover:text-blue-900 transition-colors">
                  {translations.footer?.contact ?? 'Contact'}
                </Link>
              </li>
              <li>
                <Link to="/governance#whistleblowing" className="text-[#FDA729] font-semibold hover:text-blue-900 transition-colors">
                  {translations.footer.speakUpReport ?? 'Speak Up Report'}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Section */}
          <div>
            <h3 className="text-gray-400 uppercase text-xs font-semibold tracking-wider mb-4">
              {translations.footer?.contact ?? 'Contact'}
            </h3>
            <ul className="text-xs hover:text-blue-900 transition-colors space-y-3 text-gray-700">
              <li>Aras LPH, Menara Bank Rakyat Shah Alam</li>
              <li>No. 1 Jalan Indah 14/8, Seksyen 14</li>
              <li>40000 Shah Alam, Selangor Darul Ehsan</li>
              <li className="">
                {translations.footer?.phone ?? 'Phone'}: <a href="tel:+60355187735" className="hover:text-blue-900 transition-colors">
                  +603-55187735
                </a>
              </li>
              <li className="">
                {translations.footer?.fax ?? 'Fax'}: <a href="tel:+60355187736" className="hover:text-blue-900 transition-colors">
                  +603-55187736
                </a>
              </li>
              <li>
                {translations.footer?.email ?? 'Email'}: <a href="mailto:info@semesta.com.my" className="hover:text-blue-900 transition-colors">
                  info@semesta.com.my
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            {translations.footer?.copyright ?? '© 2026 KUMPULAN SEMESTA SDN BHD. All rights reserved.'}
          </p>
          <div className="flex gap-6">
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
